import { __extends } from "tslib";
import { RecognizeCelebritiesRequest, RecognizeCelebritiesResponse } from "../models/index";
import { deserializeAws_json1_1RecognizeCelebritiesCommand, serializeAws_json1_1RecognizeCelebritiesCommand, } from "../protocols/Aws_json1_1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var RecognizeCelebritiesCommand = /** @class */ (function (_super) {
    __extends(RecognizeCelebritiesCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function RecognizeCelebritiesCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    RecognizeCelebritiesCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var handlerExecutionContext = {
            logger: logger,
            inputFilterSensitiveLog: RecognizeCelebritiesRequest.filterSensitiveLog,
            outputFilterSensitiveLog: RecognizeCelebritiesResponse.filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    RecognizeCelebritiesCommand.prototype.serialize = function (input, context) {
        return serializeAws_json1_1RecognizeCelebritiesCommand(input, context);
    };
    RecognizeCelebritiesCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_json1_1RecognizeCelebritiesCommand(output, context);
    };
    return RecognizeCelebritiesCommand;
}($Command));
export { RecognizeCelebritiesCommand };
//# sourceMappingURL=RecognizeCelebritiesCommand.js.map